import Step from '@/lib/Step';
import {ResponseGroup} from '@/lib/ResponseGroup';
import {BranchCategory} from "@/lib/BranchCategory";
import Section from './Section';
import {Question as QuestionEntity, Question} from './Question';
import store from '../store';

export default class Branch {
    public steps: Step[] = [];
    public currentStep?: Step;
    public responseGroups: ResponseGroup[] = [];
    private currentQuestion?: Question;
    private currentQuestionPosition = 0;
    private questions: Question[] = [];
    private validQuestions: Question[] = [];
    constructor(
        public id: number,
        public title: string,
        public description: string = '',
        public icon = '',
        public picture: string = '',
        public slug: string = '',
        public category: BranchCategory,
        public activated = false,
        public activateComparison = false,
        public noComparisonNotice = '',
        public excelTemplateFile = '',
        public hubspotFormId = '',
        public ranking = 0,
        public showOnHomepage = true,
        public filters: any = [],
        public noDeductible = false,
    ) {
    }

    get questionCount() {
        return this.questions.length;
    }

    get progress() {
        const displayed = this.questions.filter((question: QuestionEntity) => question.canDisplay());
        const length = displayed.length;
        if(length === 0){
            return 0;
        }
        const position = this.currentQuestionPosition;
        return position * 100 / length;
    }

    public next() {
        if(this.currentQuestion){
            this.dispatchQuestions();
        }
    }

    public previous() {
        this.currentQuestionPosition = this.currentQuestionPosition - 1;
        this.currentQuestion = this.validQuestions[this.currentQuestionPosition];
    }



    public dispatchQuestions() {
        const backUpCurrentQuestion = this.currentQuestion;
        const backUpCurrentQuestionPosition = this.currentQuestionPosition;
        let hasInvalidQuestion = false;
        let reachedCurrentQuestion = false;
        this.questions = [];
        this.validQuestions = [];
        this.steps.forEach((step: Step) => {
            step.sections.forEach((section: Section) => {
                section.questions.forEach((question: Question) => {
                    if( question.responseType.template === 'sub-question' && !question.children.length){
                        const children = store.state.questions.filter(
                            (current: QuestionEntity) => current.parentId === question.id
                        );
                        children.forEach((child: QuestionEntity) =>{
                            question.children.push(child);
                            child.parent = question;
                        });
                    }
                    if(question.canDisplay() && !question.parentId){
                        this.questions.push(question);
                        if( !reachedCurrentQuestion){
                            const good = question.stepValidation();
                            if (good && !hasInvalidQuestion) {
                                this.validQuestions.push(question);
                            } else {
                                hasInvalidQuestion = true;
                            }
                        }
                        if (this.currentQuestion && question.id === this.currentQuestion.id) {
                            reachedCurrentQuestion = true;
                        }
                    }
                });
            });
        });

        let currentQuestionPosition = this.validQuestions.length ? this.currentQuestionPosition : -1;

        if (this.validQuestions.length < this.questions.length) {

            if ( currentQuestionPosition === this.validQuestions.length - 1 || !this.validQuestions.length) {
                this.validQuestions.push(this.questions[this.validQuestions.length]);
                currentQuestionPosition = this.validQuestions.length - 1;
                this.currentQuestion = this.validQuestions[currentQuestionPosition];
                this.currentQuestionPosition = currentQuestionPosition;
            }else{
                this.currentQuestionPosition = this.currentQuestionPosition + 1;
                this.currentQuestion = this.validQuestions[this.currentQuestionPosition];
            }
        }else{
            this.currentQuestionPosition = this.validQuestions.length - 1;
            this.currentQuestion = this.validQuestions[this.currentQuestionPosition];
        }
        if(!this.currentQuestion){
            this.currentQuestion = backUpCurrentQuestion;
            this.currentQuestionPosition = backUpCurrentQuestionPosition;
        }
        // console.log(this.currentQuestion!.label);
    }

    public addStep(step: Step) {
        this.steps.push(step);
        if (!this.currentStep) {
            this.currentStep = this.steps[0];
        }
    }
}
